var url = {
    isTest: process.env.NODE_ENV === 'development',
    getHost: function () {
        if (this.isTest)
            return 'localhost:5084';
        return 'manage.sandaojapan.com';
    },
    getDomain: function () {
        if (this.isTest)
            return `http://${this.getHost()}`;
        return `http://${this.getHost()}`;
    },
    getController: function (controller, action) {
        if (action)
            return `${this.getDomain()}/${controller}/${action}`;
        else
            return `${this.getDomain()}/${controller}`;
    },
    //UE服务端接口
    getUE: function () {
        return this.getController('api/ueditor');
    },
    //UE配置地址
    getUEConfig: function () {
        if (this.isTest)
            return '/UEditor/';
        return '/vue/UEditor/';
    },
    //统一上传地址
    getUpload: function () {
        if (this.isTest)
            return "ws://" + this.getHost() + "/upload/common";
        return "ws://" + this.getHost() + "/upload/common";
    },
    getCompany: function (str) {
        return this.getController('company', str);
    },
    getAccount(str) {
        return this.getController('api/account', str);
    },
    getCategory(str) {
        return this.getController('categoryinfo', str);
    },
    getSubject(str) {
        return this.getController('subjectinfo', str);
    },
    getCards(str) {
        return this.getController('cardsinfo', str);
    },
    getSys(str) {
        return this.getController('api/sys', str);
    },
    getCollect(str) {
        return this.getController('api/collect', str);
    },
    getBaseData(str) {
        return this.getController('api/basedata', str);
    },
    getArt(str) {
        return this.getController('api/art', str);
    },
    getSch(str) {
        return this.getController('api/sch', str);
    },
    getCommon(str) {
        return this.getController('api/common', str);
    },
    getVideo(str) {
        return this.getController('api/video', str);
    },
    getJapanese(str) {
        return this.getController('api/japanese', str);
    },
}
export default url;